/* Outlet - filtro de categorias na pagina inteira */
(function () {
  function init(root) {
    if (!root || root.dataset.outletReady === '1') return;
    root.dataset.outletReady = '1';

    var chips = root.querySelectorAll('.nv-out-chip');
    var faixas = root.querySelectorAll('[data-faixa]');

    function aplicar(cat) {
      chips.forEach(function (c) {
        var on = c.dataset.cat === cat;
        c.classList.toggle('nv-on', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      faixas.forEach(function (sec) {
        var visiveis = 0;
        sec.querySelectorAll('.nv-out-item').forEach(function (item) {
          var mostrar = cat === 'all' || item.dataset.cat === cat;
          item.hidden = !mostrar;
          if (mostrar) visiveis++;
        });
        sec.hidden = visiveis === 0;
        var contador = sec.querySelector('[data-count]');
        if (contador) {
          contador.textContent = visiveis + (visiveis === 1 ? ' produto' : ' produtos');
        }
      });
    }

    root.addEventListener('click', function (e) {
      var chip = e.target.closest('.nv-out-chip');
      if (!chip) return;
      e.preventDefault();
      aplicar(chip.dataset.cat);
    });
  }

  function boot() {
    document.querySelectorAll('[data-outlet]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* o editor de temas recarrega a secao sem recarregar a pagina */
  document.addEventListener('shopify:section:load', boot);
})();
